import { library } from '@fortawesome/fontawesome-svg-core';
import {faBars,faChevronLeft, faChevronRight, faExpandArrowsAlt, faEye, faEyeSlash, faInfoCircle, faMinus, faPlus, faSearch, faShoppingBag, faStar, faStarHalfAlt, faTimes, faTrashAlt} from "@fortawesome/free-solid-svg-icons";
import {faTrashAlt as faTrashAltlRegular, faStar as faStarRegular} from '@fortawesome/free-regular-svg-icons';
library.add(
  faExpandArrowsAlt,
  faShoppingBag,
  faBars,
  faTimes,
  faSearch,
  faEyeSlash,
  faEye,
  faInfoCircle,
  faTrashAlt,
  faTrashAltlRegular,
  faChevronLeft,
  faChevronRight,
  faMinus,
  faPlus,
  faStar,
faStarHalfAlt,
faStarRegular
);